import * as service from './service';

export const examDatesForLocationsStore = {
  service,
};
